







































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Documents extends Vue {
    @Prop({ default: () => [] })
    private documents!: any[];

    private getDocStatusClass(st: string): string {
        switch (st) {
            case 'hoan_thanh':
                return 'label-success';
            case 'da_gui_kh':
                return 'label-info';
            case 'chua_hoan_thanh':
            default:
                return 'label-warning';
        }
    }
}
